var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "dashboard-v1" },
      [
        _c("el-row", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "card-style card-layout"
            },
            [
              _c("div", { staticClass: "card-left" }, [
                _c("div", { staticClass: "card-left-wrapper" }, [
                  _c("div", { staticClass: "profile-image" }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "6em",
                          color: "DeepSkyBlue"
                        }
                      },
                      [_c("i", { staticClass: "fas fa-cloud" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "information" }, [
                    _vm.data
                      ? _c("div", { staticClass: "property load-up" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("dashboard.merchant.organizationName")
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.data.organizationName) +
                                "\n                  "
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "information" }, [
                    _vm.data
                      ? _c("div", { staticClass: "property load-up" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("dashboard.merchant.organizationCode")
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.data.organizationCode) +
                                "\n                  "
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "information" }, [
                    _vm.data
                      ? _c("div", { staticClass: "property load-up" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "dashboard.merchant.organizationStatus"
                                  )
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "value" },
                            [
                              _c(
                                "el-tag",
                                { attrs: { type: _vm.orgStatus.orgType } },
                                [_vm._v(_vm._s(_vm.orgStatus.orgStatus))]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "information" }, [
                    _vm.data
                      ? _c("div", { staticClass: "property load-up" }, [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t("dashboard.merchant.approvalStatus")
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "value" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.approvalStatus.approvalType
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.approvalStatus.approvalStatus)
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-right" }, [
                _c(
                  "div",
                  { staticClass: "card-right-wrapper" },
                  [
                    _c("div", { staticClass: "info-row" }, [
                      _vm.data
                        ? _c("div", { staticClass: "property load-up w-40" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("dashboard.merchant.accessNumber")
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.data.property.systemId) +
                                  "\n                  "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data
                        ? _c("div", { staticClass: "property load-up w-20" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("dashboard.merchant.accessCode")
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.data.property.password) +
                                  "\n                  "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data
                        ? _c("div", { staticClass: "property load-up w-20" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "dashboard.merchant.numberOfConnections"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.data.property.channelLine) +
                                  "\n                  "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data
                        ? _c("div", { staticClass: "property load-up w-20" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("dashboard.merchant.channelRate")
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.data.property.channelLimit) +
                                  "\n                  "
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _vm.data
                        ? _c("div", { staticClass: "property w-40 load-up" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("dashboard.merchant.md5Key")) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "value" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.data.MD5Key) +
                                  "\n                  "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data
                        ? _c("div", { staticClass: "property w-40 load-up" }, [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("dashboard.merchant.goToDocs")
                                  ) +
                                  "\n                  "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "value" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "success", size: "mini" },
                                    on: { click: _vm.redirectToDocs }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dashboard.merchant.redirectToDocs"
                                        )
                                      ) + "\n                    "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.httpAPI || _vm.smppAPI
                      ? _c("div", { staticClass: "info-row" }, [
                          _vm.httpAPI
                            ? _c(
                                "div",
                                { staticClass: "property w-40 load-up" },
                                [
                                  _c("div", { staticClass: "label" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "dashboard.merchant.HTTPAPIText"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.httpAPI) +
                                        "\n                  "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.smppAPI
                            ? _c(
                                "div",
                                { staticClass: "property w-40 load-up" },
                                [
                                  _c("div", { staticClass: "label" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "dashboard.merchant.SMPPAPIText"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.smppAPI) +
                                        "\n                  "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "inside-card" }, [
                      _c("div", { staticClass: "card-info" }, [
                        _vm.data
                          ? _c("div", { staticClass: "property load-up" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.$t("dashboard.lastLoginTime")) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.data.lastLoginTime) +
                                    "\n                    "
                                )
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-icon",
                          staticStyle: { background: "LightSteelBlue" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "2.5em",
                                color: "White"
                              }
                            },
                            [_c("i", { staticClass: "fas fa-globe" })]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-info" }, [
                        _vm.data
                          ? _c("div", { staticClass: "property load-up" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.$t("dashboard.lastLoginIp")) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.data.lastLoginIp) +
                                    "\n                    "
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.cardInfo, function(pair, i) {
                      return _c("CardInfo", { key: i, attrs: { pair: pair } })
                    })
                  ],
                  2
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("el-row", [
          _c(
            "div",
            { staticClass: "card-style", staticStyle: { padding: "20px" } },
            [
              _c("div", { staticClass: "graph-title" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.merchant.top5Pay")))
              ]),
              _vm._v(" "),
              _vm.values.filter(function(v) {
                return v !== 0
              }).length
                ? _c("bar-chart", {
                    ref: "barChart",
                    attrs: {
                      labels: _vm.labels,
                      values: _vm.values,
                      placeholder: _vm.$t("dashboard.merchant.numSuccesses")
                    }
                  })
                : _c("div", { staticClass: "no-data" }, [
                    _vm._v(_vm._s(_vm.$t("common.noData")))
                  ])
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }